import { useEffect } from "react";

export default function LatestPics() {
  useEffect(() => {
    fetch("https://docs.google.com/spreadsheets/d/1wPQHcHKK309jofvkBwuRFitcqcnKMlkePmkxTv1Wc6I/gviz/tq?tqx=out:csv")
      .then(res => res.text())
      .then(text => {
        const lines = text.trim().split("\n");
        const firstRow = lines[1].split(",");
        const latestLink = firstRow[1].replace(/^"|"$/g, "");
        window.location.href = latestLink;
      })
      .catch(err => console.error("Error fetching Google Sheet:", err));
  }, []);
    
  console.log("Latest Pics");
  return <p>Redirecting to the latest photo...</p>;
}
